var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 34C19 32.3431 20.3431 31 22 31H34C35.6569 31 37 32.3431 37 34V46C37 47.6569 35.6569 49 34 49H22C20.3431 49 19 47.6569 19 46V34ZM22 33C21.4477 33 21 33.4477 21 34V46C21 46.5523 21.4477 47 22 47H34C34.5523 47 35 46.5523 35 46V34C35 33.4477 34.5523 33 34 33H22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 55C20.3431 55 19 56.3431 19 58V70C19 71.6569 20.3431 73 22 73H34C35.6569 73 37 71.6569 37 70V58C37 56.3431 35.6569 55 34 55H22ZM21 58C21 57.4477 21.4477 57 22 57H34C34.5523 57 35 57.4477 35 58V70C35 70.5523 34.5523 71 34 71H22C21.4477 71 21 70.5523 21 70V58Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 58C43 56.3431 44.3431 55 46 55H58C59.6569 55 61 56.3431 61 58V70C61 71.6569 59.6569 73 58 73H46C44.3431 73 43 71.6569 43 70V58ZM46 57C45.4477 57 45 57.4477 45 58V70C45 70.5523 45.4477 71 46 71H58C58.5523 71 59 70.5523 59 70V58C59 57.4477 58.5523 57 58 57H46Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 31C44.3431 31 43 32.3431 43 34V46C43 47.6569 44.3431 49 46 49H58C59.6569 49 61 47.6569 61 46V34C61 32.3431 59.6569 31 58 31H46ZM45 34C45 33.4477 45.4477 33 46 33H58C58.5523 33 59 33.4477 59 34V46C59 46.5523 58.5523 47 58 47H46C45.4477 47 45 46.5523 45 46V34Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 9H76C78.2091 9 80 10.7909 80 13V76C80 78.2091 78.2091 80 76 80H4C1.79086 80 0 78.2091 0 76V13C0 10.7909 1.79086 9 4 9H16V1C16 0.447715 16.4477 0 17 0C17.5523 0 18 0.447715 18 1V9H62V1C62 0.447715 62.4477 0 63 0C63.5523 0 64 0.447715 64 1V9ZM18 18V11H62V18C62 18.5523 62.4477 19 63 19C63.5523 19 64 18.5523 64 18V11H76C77.1046 11 78 11.8954 78 13V24H2V13C2 11.8954 2.89543 11 4 11H16V18C16 18.5523 16.4477 19 17 19C17.5523 19 18 18.5523 18 18ZM2 26V76C2 77.1046 2.89543 78 4 78H76C77.1046 78 78 77.1046 78 76V26H2Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyEvents);
export default __webpack_public_path__ + "static/media/empty-events.d56b25fe89cd90941920adf104ebe64b.svg";
export { ForwardRef as ReactComponent };